import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

function CircleQuestionMark({
  color = 'status.pink',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase width='22' height='22' viewBox='0 0 22 22' {...props}>
      <Rect x='0.5' y='0.5' width='21' height='21' rx='10.5' fill={fill} />
      <Rect
        x='0.5'
        y='0.5'
        width='21'
        height='21'
        rx='10.5'
        stroke={color}
        fill={fill}
      />
      <Path
        d='
          M11.0016 12.5162
          V10.9095
          C12.1848 10.9095 13.1439 9.9504 13.1439 8.76726
          C13.1439 7.58412 12.1848 6.625 11.0016 6.625
          C9.8185 6.625 8.85938 7.58412 8.85938 8.76726'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='
          M11.0043 15.1383
          C10.9747 15.1383 10.9508 15.1622 10.9508 15.1918
          C10.9508 15.2214 10.9747 15.2454 11.0043 15.2454
          C11.0339 15.2454 11.0579 15.2214 11.0579 15.1918
          C11.0579 15.1622 11.0339 15.1383 11.0043 15.1383
        '
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

CircleQuestionMark.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default CircleQuestionMark
